import React from "react";
import PropTypes from "prop-types";
import { Box, Flex } from "@chakra-ui/react";
import FixedPlugin from "theme-components/fixedPlugin/FixedPlugin";

function AuthIllustration({ children, illustrationBackground }) {
  return (
    <Flex position="relative" h="max-content">
      <Flex
        h={{ sm: "initial", lg: "100vh", xl: "97vh" }}
        w="100%"
        maxW={{ md: "66%", lg: "1313px" }}
        mx="auto"
        pt={{ sm: "50px", md: "0" }}
        px={{ lg: "30px", xl: "0" }}
        ps={{ xl: "70px" }}
        justify="center"
        direction="column"
      >
        {children}
      </Flex>

      <Box
        display={{ base: "none", md: "block" }}
        h="100%"
        minH="100vh"
        w={{ lg: "50vw", "2xl": "44vw" }}
        position="absolute"
        right="0"
      >
        <Flex
          bgImage={`url(${illustrationBackground})`}
          justify="center"
          align="end"
          w="100%"
          h="100%"
          bgSize="cover"
          bgPosition="50%"
          position="absolute"
          borderBottomLeftRadius={{ lg: "120px", xl: "200px" }}
        />
      </Box>

      <FixedPlugin />
    </Flex>
  );
}

AuthIllustration.propTypes = {
  illustrationBackground: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default AuthIllustration;
